class MenuMobile {

    // 1. describe and create/initiate object
    constructor() {
        this.toggleBurgerMobile = document.querySelector("#toggleBurgerMobile")
        this.menuContainer = document.querySelector(".menu-header-mobile")
        this.menuItemHasChildren = document.querySelectorAll(".menu-item-has-children")
        this.events()
    }

    // 2. events
    events() {
        this.toggleBurgerMobile.addEventListener("click", (e) => this.toggleBurger(e))
        for (let i = 0; i < this.menuItemHasChildren.length; i++) {
            this.menuItemHasChildren[i].addEventListener("click", (e) => this.menuItemHasChildren[i].classList.toggle('submenu-open'))
        }
        window.addEventListener("resize", () => this.closeAll())
        // window.addEventListener("scroll", () => this.closeAll())
    }

    // 3. methods
    toggleBurger() {
        this.toggleBurgerMobile.classList.toggle('is-active')
        this.menuContainer.classList.toggle('show-mobile-menu')
    }
    closeAll() {
        this.toggleBurgerMobile.classList.remove('is-active')
        this.menuContainer.classList.remove('show-mobile-menu')
    }
}

export default MenuMobile